/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import _ from 'lodash';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { TextField, Grid, InputLabel, Select } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { Button } from 'react-bootstrap';

import RadioGroupComponent from '../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../SharedModules/utilities/utilities';

import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import {
  viewPortHeight_355,
  radioGroupQuarterNameDisputes,
  radioGroupQuarterDisputes,
} from '../../../SharedModules/CommonConstants/commonConstants';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import { getCheckBoxValue } from '../../Research/InvoiceAudits/store/Actions';

import {
  dispatchErrorMsgTopBalances,
  getRebateProgrameList,
  dispatchRebateProgramName,
  dispatchQuarterRange,
  dispatchManufacturerNo,
  dispatchFromBalances,
  dispatchToBalances,
  dispatchCreditDebitIndex,
  getPlanTypeValues,
  getDebitMfg,
  getCreditMfg,
  dispatchPerformResolutionObj,
  getCreditDebit,
  getDramsInvStartQtr,
  getFirstSummaryReportQuarter,
  getTopBalances,
  dispatchDateRange,
  dispatchBalanceDue,
  dispatchCreditDebit,
  dispatchDisplayObjBalances,
  setDetailTopBalList,
} from './Store/action';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED_RANGE,
  QTR_VALIDATION_ERR,
  VALIDATE_QUARTER_VALUE,
  MANUFACTURE_NO_REQUIRED,
} from '../../../SharedModules/Errors/constantMessageData';
import {
  checkQuarterValidation,
  closeTab,
  compareQtrs,
  redirectURLLink,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import { clearReduxForFilterAndSort } from '../../../SharedModules/Table/store/Actions';
import CommonModal from '../../../SharedModules/Dialog/CommonModal';

const TopBalances = (props) => {
  const {
    performResolutionObj: requestCurrentDisData,
    planType: planTypeList,
    rebateProgram: getRebateProgramList,
    rebateProgramName: getRebateProgramName,
    errorMsgTopBalances: getErrorMsg,
    from: getQuarterFrom,
    to: getQuarterTo,
    quarterRange: quarterRangeValue,
    credit: creditValue,
    balanceDue: getBalanceDueListData,
    creditDebit: getCreditDebitListData,
    debitMfg,
    creditMfg,
    dramsInvoice,
    // selectedDisplayValue,
    firstSummary: getFirstSummaryListData,
    displayObj: { selectedDisplayValue },
  } = useSelector((state) => state?.sharedState?.TopBalancesReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const dispatch = useDispatch();
  const [radioList, setRadioList] = React.useState([]);
  const [dramsData, setDramsData] = React.useState([]);
  const [firstSummaryData, setFirstSummaryData] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [quarterRange, setQuarterRange] = React.useState(quarterRangeValue);
  const [from, setfrom] = React.useState(getQuarterFrom);
  const [to, setto] = React.useState(getQuarterTo);
  const [credit, setCredit] = React.useState(creditValue);
  const [balData, setBalData] = React.useState([]);
  const [creditMfgData, setCreditMfgData] = React.useState([]);
  const [debitMfgData, setDebitMfgData] = React.useState([]);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(
    selectedDisplayValue || creditMfgData
  );

  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
              userDefaults?.rebateProgramCd
            : '-1',
          from: '',
        }
  );
  // dispatch function
  const setPerformBalScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };
  // Plan type
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // handling highlight tab
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/topBalances', true);
    } else {
      tabHighLigther('/topBalances', false);
    }
  }, [getErrorMsg]);

  //Resetting error message on input fields change
  React.useEffect(() => {
    dispatch(dispatchErrorMsgTopBalances([]));
  }, [state.planTypeCd, state.rebateProgramCd, quarterRange, from, to, credit, selectedValue])

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformBalScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformBalScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgTopBalances(unique));
  };

  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }
    if (type === 'manufactureDisplay') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) => item.field !== 'manufactureDisplay'
        );
        localErr.push({
          field: 'manufactureDisplay',
          errorType: 'manufactureDisplay',
          message: MANUFACTURE_NO_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'manufactureDisplay'
        );
      }
    }
    if (type === 'from' || type === 'to') {
      const QtrValue = autoFormateDate(value.toUpperCase());
      if (QtrValue && !_.isEmpty(QtrValue) && !_.isNaN(QtrValue)) {
        if (checkQuarterValidation(QtrValue)) {
          if (type === 'from') {
            setfrom(QtrValue);
            localErr = localErr?.filter((item) => item.field !== 'from');
            if (!to) {
              setto(QtrValue);
            }
          }
          if (type === 'to') {
            setto(QtrValue);
            localErr = localErr?.filter((item) => item.field !== 'to');
          }

          setState({ ...state, [type]: QtrValue });

          if (
            checkQuarterValidation(state?.from) &&
            checkQuarterValidation(state?.to)
          ) {
            if (compareQtrs(state?.from, state?.to)) {
              localErr.push({
                field: type,
                errorType: 'rangeInvalid',
                message: QTR_VALIDATION_ERR,
              });
            } else {
              localErr = localErr?.filter(
                (item) => item.errorType !== 'rangeInvalid'
              );
            }
          }
        } else {
          localErr =
            localErr && localErr?.filter((item) => item.field !== type);
          localErr.push({
            field: type,
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr && localErr?.filter((item) => item.field !== type);
        if (type === 'from') {
          localErr.push({
            field: type,
            errorType: 'fromRequired',
            message: QUARTER_VALUE_REQUIRED_RANGE.replace('From', 'Begin'),
          });
        }
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgTopBalances(unique));
  };
  // Rebate programe error on plan type change
  const rebateProgramName = rebateProgramList.find(
    (item) => item.id == state.rebateProgramCd
  );

  const handleCreditOptionChange = (event) => {
    const selectedOptionValue = event.target.value;
    setCredit(selectedOptionValue);
    dispatchManufacturerNo(selectedOptionValue);
    if (selectedOptionValue === '0') {
      setSelectedValue(creditMfg?.numOfCreditMfgVO?.numOfCreditMfg || '0');
    } else {
      setSelectedValue(debitMfg?.numOfCreditMfgVO?.numOfDebitMfg || '0');
    }
  };

  const handleQuarterRangeOptionChange = (event) => {
    if (quarterRange == 'Selected Range') {
      setfrom('');
      setto('');
    }
    setQuarterRange(event.target.value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter(
      (item) => item.field !== 'from' || item.field !== 'to'
    );
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgTopBalances(unique));
  };

  // credit mfg
  React.useEffect(() => {
    dispatch(dispatchManufacturerNo(''));
    if (rebateProgramName) {
      dispatch(
        getCreditMfg({
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
        })
      );
      dispatch(
        getDebitMfg({
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
        })
      );
      dispatch(
        getDramsInvStartQtr({
          rebateProgCode: rebateProgramName?.rebateProgramCd,
        })
      );
      dispatch(
        getFirstSummaryReportQuarter({
          rebateProgCode: rebateProgramName?.rebateProgramCd,
        })
      );
      // dispatch(
      //   getTopBalances({
      //     rebateProgramCd: rebateProgramName?.rebateProgramCd,
      //     startQtr: dateRange[quarterRange]?.beginDate || '',
      //     endQtr: dateRange[quarterRange]?.endDate || '',
      //     creditDebitIndex: credit,
      //   })
      // );
    }
  }, [rebateProgramName]);
  
  React.useEffect(() => {
    //setTimeout(() => {
      setCreditMfgData(creditMfg?.numOfCreditMfgVO?.numOfCreditMfg);
      setSelectedValue(
        selectedDisplayValue ||
          creditMfg?.numOfCreditMfgVO?.numOfCreditMfg ||
          '0'
      );
    //}, 100);
  }, [creditMfg]);
  
  //debit mfg
  React.useEffect(() => {
    setDebitMfgData(debitMfg?.numOfCreditMfgVO?.numOfDebitMfg);
    setSelectedValue(
      selectedDisplayValue || creditMfg?.numOfCreditMfgVO?.numOfCreditMfg || '0'
    );
  }, [debitMfg]);

  const handleChange = (event) => {
    if (event.target.value.length < 4 && event.target.value != '0') {
      setSelectedValue(event.target.value);
      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => item.field !== 'manufactureDisplay');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgTopBalances(unique));
    }
  };
  // const menuItems = [];
  // for (let i = 1; i <= 999; i += 1) {
  //   menuItems.push(
  //     <MenuItem key={i} value={i.toString()}>
  //       {i}
  //     </MenuItem>
  //   );
  // }

  React.useEffect(() => {
    setDramsData(dramsInvoice);
  }, [dramsInvoice]);

  React.useEffect(() => {
    setFirstSummaryData(getFirstSummaryListData?.firstSummaryReportQuarter);
  }, [getFirstSummaryListData]);
  const today = new Date();
  const quarter = Math.floor(today.getMonth() / 3) + 1;
  const year = today.getFullYear();
  const quarterString = quarter.toString();
  const yearString = year.toString();
  const formattedQuarter = quarterString.padStart(2);

  const currentQuarterWithYear = `${formattedQuarter}Q${yearString}`;
  const dateRange = {
    'DRAMS Invoice Start Quarter': {
      beginDate: dramsData,
      endDate: currentQuarterWithYear,
    },
    All: {
      beginDate: '1Q1991',
      endDate: currentQuarterWithYear,
    },
    'First Summary Report Quarter': {
      beginDate: firstSummaryData,
      endDate: currentQuarterWithYear,
    },

    'Selected Range': {
      beginDate: getQuarterFrom,
      endDate: getQuarterTo != '' ? getQuarterTo : currentQuarterWithYear,
    },
  };

  React.useEffect(() => {
    setBalData(getBalanceDueListData?.rebateTopBalancesReportVO);
  }, [getBalanceDueListData]);
  const [open, setOpen] = React.useState(false);

  const onClickOnSearch = async () => {
    if (selectedValue == 0) {
      setOpen(true);
      return;
    }

    let localErr = getErrorMsg || [];

    if (quarterRange === 'Selected Range' && from === '') {
      localErr = localErr && localErr?.filter((item) => item.field !== 'from');
      localErr.push({
        field: 'from',
        errorType: 'fromRequired',
        message: QUARTER_VALUE_REQUIRED_RANGE.replace('From', 'Begin'),
      });
    }

    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }

    if (!selectedValue || selectedValue == '0') {
      localErr = localErr.filter((item) => item.field !== 'manufactureDisplay');
      localErr.push({
        field: 'manufactureDisplay',
        errorType: 'manufactureDisplay',
        message: MANUFACTURE_NO_REQUIRED,
      });
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgTopBalances(unique));

    if (localErr.length === 0) {
      setSearchClicked(true);

      const response = await dispatch(
        getTopBalances({
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
          // startQtr: dateRange[quarterRange]?.beginDate || '',
          // endQtr: dateRange[quarterRange]?.endDate || '',
          creditDebitIndex: credit,
          startQtr:
            quarterRange === 'Selected Range'
              ? from
              : dateRange[quarterRange]?.beginDate,
          endQtr:
            quarterRange === 'Selected Range'
              ? to
              : dateRange[quarterRange]?.endDate || currentQuarterWithYear,
        })
      );

      let actual = [];
      if (credit === '0') {
        actual = response?.rebateTopBalancesReportVO
          ?.filter((obj) => obj.balanceDue < 0)
          .sort((a, b) => a.balanceDue - b.balanceDue)
          .filter((val, ind) => ind < selectedValue);
      } else if (credit === '1') {
        actual =
          response?.rebateTopBalancesReportVO
            ?.filter((obj) => obj.balanceDue > 0)
            .sort((a, b) => b.balanceDue - a.balanceDue)
            .filter((val, ind) => ind < selectedValue) || [];
      }
      const mfgValue = actual?.[0]?.mfgId;
    dispatch(setDetailTopBalList(actual));
      dispatch(dispatchCreditDebit([]));

      let fstRec = await dispatch(
        getCreditDebit({
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
          mfgId: [mfgValue],
          startQtr:
            quarterRange === 'Selected Range'
              ? from
              : dateRange[quarterRange]?.beginDate,
          endQtr:
            quarterRange === 'Selected Range'
              ? to
              : dateRange[quarterRange]?.endDate || currentQuarterWithYear,
        })
      );

      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchManufacturerNo(selectedValue));
      dispatch(dispatchCreditDebitIndex(credit));
      dispatch(dispatchQuarterRange(quarterRange));
      dispatch(dispatchFromBalances(from));
      dispatch(dispatchToBalances(to));
      dispatch(dispatchDateRange({ dramsData, firstSummaryData }));

      dispatch(
        dispatchDisplayObjBalances({
          rebateProgramName,
          selectedDisplayValue: selectedValue,
          credit,
          quarterRange,
          from,
          to,
          dramsData,
          firstSummaryData,
        })
      );

      if (fstRec?.rebateTopBalancesGridReportVO?.length > 0) {
        closeTab('/displaytopbalances', props.history);
        redirectURLLink(
          '/displaytopbalances',
          `Display Top ${selectedValue} ${
            credit === '0' ? 'Credit' : 'Debit'
          } Balances Due Report`,
          props.history,
          dispatch
        );
        dispatch(clearReduxForFilterAndSort('/displaytopbalances')); // Ensure this dispatch is called
      }
    }
  };

  if (
    isSearchClicked &&
    getCreditDebitListData?.rebateTopBalancesGridReportVO?.length > 0
  ) {
    // setSearchClicked(false);
    // const updateTabs =
    //   JSON.parse(localStorage.getItem('tabItemsData')) === null
    //     ? []
    //     : JSON.parse(localStorage.getItem('tabItemsData'));
    // updateTabs.push({
    //   navTo: '/displaytopbalances',
    //   value: 'Display Top Balances Report',
    // });
    // localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    // props.history.push({
    //   pathname: '/displaytopbalances',
    // });
    // dispatch(clearReduxForFilterAndSort('/displaytopbalances'));
  }
  const handlefromChange = (event) => {
    let { value } = event.target;
    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }
    setfrom(value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'from');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgTopBalances(unique));
  };

  const handletoChange = (event) => {
    let { value } = event.target;
    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }
    setto(value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'to');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgTopBalances(unique));
  };

  return (
    <>
      <div className="tabs-container">
        <Spinner load={spinnerLoader} />
        <CustomSeparator parent1="Summary Reports" parent2="Top Balances" />
        {getErrorMsg?.length > 0 ? (
          <DisplayErrorMessages
            errorMessages={
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            }
          />
        ) : null}
        <CommonModal
          open={open}
          viewAction
          className="dialog-420"
          viewHeader
          onOk={() => setOpen(false)}
          okTitle="Ok"
          onClose={() => setOpen(false)}
          modalTitle="Request Top Balances Report"
          childrenComponent={
            'Number of Manufactures to Display has to be greater than zero.'
          }
        />
        <div className="tab-body">
          {!fullScreenView && (
            <>
              <div className="row">
                <div className="col-4 frr-two-col-radio">
                  <RadioGroupComponent
                    data-testid="topBalance_PlanType"
                    id="radio-button-for-rcdd_id"
                    labelName="Plan Type"
                    required
                    optionList={radioList || []}
                    defaultValue={state && state.planTypeCd}
                    filterAction={(e) => {
                      handleOnChangeEvent(e, 'planTypeCd');
                    }}
                    className="log-batch-filter-radio frr-checkInvoiceRadio"
                  />
                </div>
                <div className="col-sm-8">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">
                      {radioGroupQuarterDisputes}
                      <span className="mandatory"> *</span>{' '}
                    </legend>
                    <div className="form-wrapper p-0 ">
                      <div className="mui-custom-form  field-xl ">
                        <RadioGroup
                          row
                          name="QuarterRange"
                          data-testid="topBalance_qtrRange"
                          value={quarterRange}
                          onChange={handleQuarterRangeOptionChange}
                          required
                        >
                          <FormControlLabel
                            value="All"
                            control={<Radio />}
                            label="All"
                            data-test="All"
                          />
                          <FormControlLabel
                            value="DRAMS Invoice Start Quarter"
                            control={<Radio />}
                            label="DRAMS Invoice Start Quarter"
                            data-test="DRAMS Invoice Start Quarter"
                          />

                          <FormControlLabel
                            value="First Summary Report Quarter"
                            control={<Radio />}
                            label="First Summary Report Quarter"
                            data-test="First Summary Report Quarter"
                          />

                          <FormControlLabel
                            value="Selected Range"
                            control={<Radio />}
                            label="Selected Quarter Range"
                            data-test="Selected Range"
                          />

                          <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                              <TextField
                                className={
                                  getErrorMsg?.length > 0
                                    ? _.map(getErrorMsg, (l) =>
                                        l.field == 'from'
                                          ? 'mandate-fields'
                                          : null
                                      )
                                    : null
                                }
                                data-testid="check_From_Date"
                                id="checkFromDate"
                                fullWidth
                                placeholder=""
                                label="Begin"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                inputProps={{
                                  id: 'checkFromDate',
                                  maxLength: 6,
                                }}
                                onChange={handlefromChange}
                                required
                                value={from}
                                disabled={quarterRange !== 'Selected Range'}
                                onBlur={(e) =>
                                  handleOnblurEvent('from', e.target.value)
                                }
                                helperText={
                                  getErrorMsg?.length > 0
                                    ? _.map(getErrorMsg, (l) =>
                                        l.field === 'from' ? l.message : null
                                      )
                                    : null
                                }
                                error={
                                  getErrorMsg?.length > 0
                                    ? _.map(getErrorMsg, (l) =>
                                        l.field == 'from' ? l.message : null
                                      )
                                    : null
                                }
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <TextField
                                className={
                                  getErrorMsg?.length > 0
                                    ? _.map(getErrorMsg, (l) =>
                                        l.field == 'to'
                                          ? 'mandate-fields'
                                          : null
                                      )
                                    : null
                                }
                                value={to}
                                data-testid="check_To_Date"
                                id="checkToDate"
                                fullWidth
                                placeholder=""
                                label="End"
                                inputProps={{
                                  id: 'checkFromDate',
                                  maxLength: 6,
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                onChange={handletoChange}
                                onBlur={(e) =>
                                  handleOnblurEvent('to', e.target.value)
                                }
                                helperText={
                                  getErrorMsg?.length > 0
                                    ? _.map(getErrorMsg, (l) =>
                                        l.field === 'to' ? l.message : null
                                      )
                                    : null
                                }
                                error={
                                  getErrorMsg?.length > 0
                                    ? _.map(getErrorMsg, (l) =>
                                        l.field == 'to' ? l.message : null
                                      )
                                    : null
                                }
                                disabled={quarterRange !== 'Selected Range'}
                              />
                            </Grid>
                          </Grid>
                        </RadioGroup>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-4">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">
                      Rebate Program<span className="mandatory"> *</span>{' '}
                    </legend>
                    <div className="form-wrapper p-0">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <TextField
                          name="rebateProgram"
                          id="rebate_program"
                          label="Rebate Program"
                          data-testid="topBalance_RebateProgram"
                          fullWidth
                          select
                          required
                          inputProps={{ maxLength: 11, id: 'rebate_program' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          className={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? 'mandate-fields frr-display-hidden-label'
                                    : 'frr-display-hidden-label'
                                )
                              : 'frr-display-hidden-label'
                          }
                          onBlur={(e) =>
                            handleOnblurEvent('rebateProgramCd', e.target.value)
                          }
                          onChange={(e) =>
                            handleOnChangeEvent(
                              e.target.value,
                              'rebateProgramCd'
                            )
                          }
                          value={
                            state && state.rebateProgramCd
                              ? state.rebateProgramCd
                              : ''
                          }
                          error={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? l.message
                                    : null
                                )
                              : null
                          }
                          helperText={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? l.message
                                    : null
                                )
                              : null
                          }
                        >
                          <MenuItem
                            key=""
                            value="-1"
                            className="frr-dropdown-blank-item"
                          />
                          {rebateProgramList?.length > 0
                            ? rebateProgramList.map((item) => {
                                return (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className="col-sm-4">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">
                      Credit/Debit<span className="mandatory"> *</span>{' '}
                    </legend>
                    <div className="form-wrapper p-0">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <RadioGroup
                          row
                          name=" Credit/Debit"
                          value={credit}
                          data-testid="topBalance_credit"
                          onChange={handleCreditOptionChange}
                          required
                        >
                          <FormControlLabel
                            style={{ marginRight: '10px' }}
                            value="0"
                            control={<Radio />}
                            label="Amount Owed to the Manufacturer (Credit)"
                          />
                          <FormControlLabel
                            style={{ marginRight: '10px' }}
                            value="1"
                            control={<Radio />}
                            label="Amount Owed to the State (Debit)"
                          />
                        </RadioGroup>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-sm-4">
                  <div className="mui-custom-form field-xl no-lbl frr-visible-counter-arrow">
                    <FormControl>
                      <p>Number of Manufacturers to Display</p>

                      <TextField
                        value={selectedValue}
                        type="number"
                        id="topBalanceManu1"
                        label="topBalanceManu"
                        data-testid="topBalance_manufactur"
                        onChange={handleChange}
                        inputProps={{
                          id: 'topBalanceManu1',
                          min: 0,
                          max: 999,
                        }}
                        className={
                          getErrorMsg?.length > 0
                            ? _.map(getErrorMsg, (l) =>
                                l.field === 'manufactureDisplay'
                                  ? 'mandate-fields frr-display-hidden-label'
                                  : 'frr-display-hidden-label'
                              )
                            : 'frr-display-hidden-label'
                        }
                        onBlur={(e) =>
                          handleOnblurEvent(
                            'manufactureDisplay',
                            e.target.value
                          )
                        }
                        error={
                          getErrorMsg?.length > 0
                            ? _.map(getErrorMsg, (l) =>
                                l.field === 'manufactureDisplay'
                                  ? l.message
                                  : null
                              )
                            : null
                        }
                        helperText={
                          getErrorMsg?.length > 0
                            ? _.map(getErrorMsg, (l) =>
                                l.field === 'manufactureDisplay'
                                  ? l.message
                                  : null
                              )
                            : null
                        }
                      >
                        {/* <MenuItem value="-1"></MenuItem>
                        {menuItems} */}
                      </TextField>
                    </FormControl>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="btn-wrapper mb-2">
                    <div className="float-right mt-2 hide-on-print">
                      <Button
                        className="btn btn-success btn-search"
                        data-testid="view_detail_ia"
                        type="button"
                        onClick={onClickOnSearch}
                      >
                        {' '}
                        <SVGComponent iconName="Icon-search" /> {'  '} Search
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default TopBalances;
